import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const RolesPluginPage = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default RolesPluginPage